// theme/theme.ts

const theme = {
  colors: {
    dark: "#303030",
    primary: "#A99637",
    secondary: "#EFE4AC",
    
  },
  fontSizes: {
    xs: '14px',
    s: "16px",
    m: "18px",
    l: "22px",
    xl: "32px",
  },
  mediaQueries: {
    s: "576px",
    m: "768px",
    l: "992px",
  },
  boxShadow: '-5px 11px 22px -18px rgba(66, 68, 90, 1)',
  textShadow: 'text-shadow: -2px 2px 5px rgba(66, 68, 90, .6)'
};

export default theme;
